import { createTheme } from '@mui/material/styles';
import { themeProps } from '../interface';

export const makeTheme = (theme?: themeProps) => {
  if (!theme) {
    return createTheme();
  }

  return createTheme({
    typography: {
      fontFamily: '"Nunito Sans", sans-serif'
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#fff',
              color: '#000'
            },
            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
              display: 'none'
            },
            '& input[type=number]': {
              MozAppearance: 'textfield'
            }
          }
        }
      },
      MuiCssBaseline: {
        styleOverrides: `
                @font-face {
                  font-family: "Nunito Sans", sans-serif;
                  font-style: normal;
                  font-display: swap;
                  font-weight: 400;
                  text-transform: none;
                  font-size: 16px;
                }
              `
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: theme.fontFamily.secondary,
            textTransform: 'none',
            borderRadius: '4px',
            fontWeight: 500,
            fontSize: '16px',
            backgroundColor: theme.color.buttonTextColor,
            color: theme.color.headerBackground,
            padding: '6px 12px',
            '&:hover': {
              backgroundColor: theme.color.primary,
              color: theme.color.headerBackground
            },
            '&:disabled': {
              backgroundColor: theme?.color?.grey,
              color: theme?.color?.secondary
            }
          }
        }
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            border: `1px solid ${theme.color.headerBorderColor}`,
            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.08)',
            borderRadius: '4px'
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: '16px',
            backgroundColor: '#000',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#000'
            }
          }
        }
      },
      MuiDivider: {
        variants: [
          {
            props: {
              orientation: 'horizontal'
            },
            style: {
              ':before': {
                borderTop: 'thin solid #D7D8DB'
              },
              ':after': {
                borderTop: 'thin solid #D7D8DB'
              }
            }
          }
        ]
      }
    },
    palette: {
      primary: {
        main: theme?.color.primary,
        dark: '#242629'
      },
      secondary: {
        main: theme?.color.secondary,
        light: theme?.color.tertiary
      },
      border: {
        dark: '#616161',
        light: '#E0E0E0'
      },
      appDefaultColor: {
        primary: {
          dark: '#00000',
          light: '#FFFFFF80'
        },
        secondary: {
          dark: '#000000',
          light: '#353535'
        }
      },
      background: {
        paper: theme?.color?.backgroundColor,
        default: theme?.color.textColorPrimary
      },
      text: {
        primary: theme?.color.textColorPrimary,
        secondary: '#fff'
      },
      grey: {
        50: '#000',
        100: theme.color.grey,
        200: '#242629',
        400: '#fff'
      },
      divider: '#fff',
      toastWarning: {
        50: '#FFFFE5',
        100: '#FFFEC0',
        200: '#FCFB99',
        300: '#F8F676',
        400: '#F5F15C',
        500: '#F0EB47',
        600: '#FBDF47',
        700: '#FDC740',
        800: '#FCAD36',
        900: '#F98028'
      },
      toastError: {
        50: '#FEE3E5',
        100: '#FDBBBD',
        200: '#E2807A',
        300: '#CD564F',
        400: '#D0372E',
        500: '#CE2818',
        600: '#BF1E18',
        700: '#AD1414',
        800: '#9F0C10',
        900: '#90030F'
      }
    },
    ClaimTemplate: {
      Header: {
        background: theme?.color?.headerBackground,
        borderColor: theme.color.headerBorderColor,
        color: theme?.color.headerColor
      },
      Footer: {
        background: theme?.color?.footerBackground,
        color: theme?.color?.footerColor
      },
      pagination: {
        backgroundColor: theme.color.paginationBackground,
        selectedPageColor: theme.color.paginationSelectedPageColor
      },
      linkColor: theme?.color?.linkColor,
      membershipURLBackgroundColor: theme?.color?.membershipURLBackgroundColor,
      placeholderColor: theme.color.placeholderColor,
      checkBoxColor: theme.color.checkBoxColor,
      menuButtonBorder: theme.color.menuButtonBorder,
      collectionHeaderColor: '#8C939E',
      tokenNameColor: '#fff',
      deliveryInprogressColor: '#A9AFB8'
    },
    MojitoClaim: {
      delivery: {
        textColor: theme?.color?.deliveryTextColor,
        tokenTrackerColor: theme?.color?.tokenTrackerColor
      },
      error: theme.color.error,
      linkColor: theme?.color?.primary,
      Discount: {
        inProgressColor: '#F98028',
        inProgressBackground: '#FFFEC0'
      },
      success: '#3E8045',
      deliveryBackgroundColor: theme?.color?.deliveryBackgroundColor,
      font: {
        primary: theme.fontFamily.primary,
        secondary: theme.fontFamily.secondary,
        tertiary: theme.fontFamily.tertiary
      }
    }
  });
};
